import React, { useState } from "react";

import AILightComponent from '../../components/AILightComponent';
import { categories } from "../agrilink/AgriLinkChroniclesHome";

/* -------------------- DATA -------------------- */

const services = [
  {
    category: "Business Setup",
    items: ["Pvt Ltd", "LLP", "OPC", "Partnership"],
  },
  {
    category: "Tax & Compliance",
    items: ["GST Registration", "GST Filing", "ITR Filing"],
  },
  {
    category: "Licenses",
    items: ["FSSAI", "MSME", "Shop Act", "IEC"],
  },
  {
    category: "IPR",
    items: ["Trademark", "Copyright", "Patent"],
  },
  {
    category: "Legal Docs",
    items: ["Agreements", "NDA", "Contracts"],
  },
  {
    category: "HR & Payroll",
    items: ["Payroll Setup", "PF/ESIC"],
  },
];

/* -------------------- MAIN -------------------- */

export default function Compliancify() {
  const [menu, setMenu] = useState(false);
  const [selected, setSelected] = useState(null);
  const [admin, setAdmin] = useState(false);

  const [leads, setLeads] = useState([]);
  const [orders, setOrders] = useState([]);

  /* ---------------- AI SUGGEST ---------------- */
  const getSuggestion = (input) => {
    if (input.includes("food")) return "FSSAI License";
    if (input.includes("startup")) return "Pvt Ltd Registration";
    if (input.includes("brand")) return "Trademark";
    return "GST Registration";
  };

  /* ---------------- CALCULATORS ---------------- */
  const [gst, setGst] = useState(0);
  const [gstRate, setGstRate] = useState(18);

  const [revenue, setRevenue] = useState(0);
  const [cost, setCost] = useState(0);

  /* ---------------- MOCK PAYMENT ---------------- */
  const mockPay = (service) => {
    alert(`Mock Payment Successful for ${service}`);
    setOrders([
      ...orders,
      { service, status: "Paid", id: Date.now() },
    ]);
  };

  /* ---------------- WHATSAPP ---------------- */
  const sendWhatsApp = (name) => {
    alert(`WhatsApp message sent to ${name}`);
  };

  /* ---------------- LEAD ---------------- */
  const addLead = (name, service) => {
    const newLead = {
      id: Date.now(),
      name,
      service,
      status: "New",
    };
    setLeads([...leads, newLead]);
  };

  const [showAI, setShowAI] = useState(false);
  const [aiInput, setAiInput] = useState("");

  const handleSuggest = () => {
    if (!aiInput.trim()) return;
    setShowAI(true);
  };

  return (
    <div className="bg-black text-white [&_p]:text-white [&_li]:text-white min-h-screen">

      {/* HEADER */}
      <header className="flex justify-between p-4 border-b border-gray-800">
        <div className="flex flex-col justify-start">
          <h1 className="flex text-start font-bold text-lg lg:text-xl text-yellow-200">Compliancify</h1>
          <h2 className="text-xs lg:text-sm text-white">All Compliance in One Place</h2>
        </div>
        <div className="flex gap-4">
          <button onClick={() => setMenu(true)}>☰</button>
          <button onClick={() => setAdmin(!admin)}>Admin</button>
        </div>
      </header>

      {/* MENU */}
      {menu && (
        <div className="fixed inset-0 bg-black p-6 z-50 overflow-y-auto">
          <button onClick={() => setMenu(false)}>Close</button>

          {services.map((cat, i) => (
            <div key={i}>
              <h2 className="mt-4 font-bold text-cyan-200">{cat.category}</h2>

              {cat.items.map((item, j) => (
                <div
                  key={j}
                  className="p-2 border border-gray-800 mt-2"
                  onClick={() => {
                    setSelected(item);
                    setMenu(false);
                  }}
                >
                  {item}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* AI SUGGEST */}
      <div className="p-4 border-t border-gray-800 space-y-3">
        <div className="flex gap-2">
          <input
            placeholder="Describe your need..."
            value={aiInput}
            onChange={(e) => setAiInput(e.target.value)}
            className="flex-1 p-2 bg-gray-900 border border-gray-700 rounded"
          />
          <button
            onClick={handleSuggest}
            className="bg-cyan-600 px-4 py-2 rounded w-32"
          >
            Suggest
          </button>
        </div>

        {aiInput && (
          <div className="text-xs text-gray-100">
            ⚡ {getSuggestion(aiInput.toLowerCase())}
          </div>
        )}

        {showAI && (
          <div className="mt-3 border border-gray-700 rounded p-2">
            <AILightComponent
              param1={"Eisenhower Matrix"}
              param2={aiInput}
            />
          </div>
        )}
      </div>

      {/* CALCULATORS */}
      <div className="p-6 border-t border-gray-800">
        <h2 className="text-cyan-200">GST Calculator</h2>
        <input
          type="number"
          placeholder="Amount"
          className="rounded-md p-2 mr-4"
          onChange={(e) => setGst(e.target.value)}
        />
        <input
          type="number"
          placeholder="Rate"
          value={gstRate}
          className="rounded-md p-2 mr-4"
          onChange={(e) => setGstRate(e.target.value)}
        />
        <p>GST: ₹{(gst * gstRate) / 100}</p>

        <h2 className="mt-4 text-cyan-200">Profit Calculator</h2>
        <input
          placeholder="Revenue"
          className="rounded-md p-2 mr-4"
          onChange={(e) => setRevenue(e.target.value)}
        />
        <input
          placeholder="Cost"
          className="rounded-md p-2"
          onChange={(e) => setCost(e.target.value)}
        />
        <p>Profit: ₹{revenue - cost}</p>
      </div>

      {/* SERVICE DRAWER */}
      {selected && (
        <div className="fixed bottom-0 bg-black w-full p-4 border-t border-gray-800">
          <h2 className="text-yellow-200">{selected}</h2>

          <input
            placeholder="Your Name"
            id="name"
            className="w-full p-2 bg-gray-900 mt-2"
          />

          <div className="flex felx-row gap-2">
            <button
              className="mt-2 bg-white text-black p-2 w-full"
              onClick={() => {
                const name = document.getElementById("name").value;
                addLead(name, selected);
                sendWhatsApp(name);
              }}
            >
              Request Callback
            </button>

            <button
              className="mt-2 bg-green-500 p-2 w-full"
              onClick={() => mockPay(selected)}
            >
              Pay Now
            </button>

            <button className="mt-2 bg-gray-600 p-2 w-full" onClick={() => setSelected(null)}>Close</button>
          </div>
        </div>
      )}

      {/* ADMIN PANEL */}
      {admin && (
        <div className="p-6 border-t border-gray-800">
          <h2 className="text-xl text-cyan-200">Admin Panel</h2>

          <h3 className="mt-4">Leads</h3>
          {leads.map((l) => (
            <div key={l.id} className="border p-2 mt-2">
              {l.name} - {l.service} - {l.status}
              <button
                onClick={() =>
                  (l.status = "Processing") && setLeads([...leads])
                }
              >
                Process
              </button>
            </div>
          ))}

          <h3 className="mt-4">Orders</h3>
          {orders.map((o) => (
            <div key={o.id} className="border p-2 mt-2">
              {o.service} - {o.status}
            </div>
          ))}
        </div>
      )}

      {/* FOOTER */}
      <footer className="text-center p-6 text-gray-500">
        © Compliancify Super App Prototype
      </footer>
    </div>
  );
}